export default "__VITE_ASSET__C10bB5dq__"